import { useEffect, useRef } from 'react';
import {
	getSiteVisitRecordingElapsedMs,
	stopSiteVisitRecording,
} from '@services/siteVisitRecording/siteVisitRecordingEngine';
import { isSiteVisitRecordingActive, useSiteVisitRecordingStore } from '@store/siteVisitRecordingStore';

const BDE_FEEDBACK_MAX_DURATION_MS = 15 * 60 * 1000;
const LIMIT_CHECK_INTERVAL_MS = 1000;

/** Hard-stops BDE Feedback recording at 15 minutes (no reminder popup). */
export function BdeFeedbackDurationLimitHandler(): null {
	const phase = useSiteVisitRecordingStore((s) => s.phase);
	const uploadOnStop = useSiteVisitRecordingStore((s) => s.uploadOnStop);
	const hardStopTriggeredRef = useRef(false);
	const isBdeFeedbackActive = uploadOnStop && isSiteVisitRecordingActive(phase);

	useEffect(() => {
		if (!isBdeFeedbackActive) {
			hardStopTriggeredRef.current = false;
			return;
		}

		const checkDurationLimit = (): void => {
			const elapsedMs = getSiteVisitRecordingElapsedMs();
			if (elapsedMs >= BDE_FEEDBACK_MAX_DURATION_MS && !hardStopTriggeredRef.current) {
				hardStopTriggeredRef.current = true;
				stopSiteVisitRecording();
			}
		};

		checkDurationLimit();
		const intervalId = window.setInterval(checkDurationLimit, LIMIT_CHECK_INTERVAL_MS);
		return (): void => window.clearInterval(intervalId);
	}, [isBdeFeedbackActive]);

	return null;
}
